<template>
  <div class="content">
    <template>
      <EmptyState v-if="!accounts.length" />
      <div v-else>
        <AccountListWrapper>
          <AccountItem
            v-for="account in accounts"
            :key="account.id"
            :item="account"
            @delete-account="$emit('delete-account', account.id)"
          />
        </AccountListWrapper>
      </div>
    </template>
  </div>
</template>

<script>
import EmptyState from "@/components/AppleMaps/EmptyState.vue";
import AccountItem from "@/components/AppleMaps/AccountItem.vue";
import AccountListWrapper from "@/components/AppleMaps/AccountListWrapper.vue";

export default {
  name: "AccountsContainer",
  components: {
    EmptyState,
    AccountItem,
    AccountListWrapper
  },
  props: {
    accounts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false
    };
  }
};
</script>
<style scoped lang="scss">
.content {
  min-height: 100px;
}
</style>
